export type CompanyOption = {
  value: number;
  label: string;
};

type RawCompanyOption = {
  value: string | number;
  label?: string | null;
};

export const normalizeCompanyOptions = (
  raw: RawCompanyOption[] | null | undefined,
): CompanyOption[] =>
  (raw ?? [])
    .map((option) => ({ value: Number(option.value), label: String(option.label ?? '') }))
    .filter((option) => Number.isFinite(option.value));

export const parseStoredCompanyId = (stored: string | null): number | null => {
  if (stored === null || stored.trim() === '') return null;
  const parsed = Number(stored);
  if (!Number.isFinite(parsed) || parsed <= 0) return null;
  return parsed;
};

export const resolveActiveCompanyId = (
  stored: string | null,
  companies: CompanyOption[],
): number | null => {
  if (companies.length === 0) return null;

  if (stored !== null && stored.trim() !== '') {
    const storedId = Number(stored);
    if (Number.isFinite(storedId)) {
      const match = companies.find((company) => company.value === storedId);
      if (match) return match.value;
    }
  }

  return companies[0].value;
};

export const companyInitials = (name: string): string => {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return `${words[0][0]}${words[1][0]}`.toUpperCase();
};

export const shouldPersistActiveCompanyId = (
  stored: string | null,
  resolved: number | null,
): boolean => {
  if (resolved === null) return false;

  const requested = parseStoredCompanyId(stored);
  if (requested === null) return true;

  return requested === resolved;
};

export const isCompanyEditPath = (pathname: string, companiesBasePath: string): boolean => {
  const prefix = `${companiesBasePath}/`;
  if (!pathname.startsWith(prefix)) return false;

  const segment = pathname.slice(prefix.length).replace(/\/$/, '');
  return /^\d+$/.test(segment);
};
